import { render, staticRenderFns } from "./storageLocationAction.vue?vue&type=template&id=9aa77d12"
import script from "./storageLocationAction.vue?vue&type=script&lang=js"
export * from "./storageLocationAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports